import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Metric } from '../../../core/models/case.model';
import { CaseService } from '../../../core/services/case.service';
import { forkJoin, take } from 'rxjs';

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidenav.component.html',
})
export class SidenavComponent implements OnInit {
  metrics = signal<Metric[]>([]);
  activeFilter = this.caseService.activeFilter;

  constructor(private caseService: CaseService, private router: Router) {}

  ngOnInit(): void {
    this.loadMetrics();
  }

  onReferNewCase(): void {
    this.router.navigate(['/case/new']);
  }

  private loadMetrics(): void {
    const iconMap: { [key: string]: string } = {
      Draft: 'edit_note',
      Pending: 'pending_actions',
      Active: 'check_circle',
      Completed: 'done_all',
      Cancelled: 'content_paste_off',
    };

    forkJoin({
      draft: this.caseService.getDraftCaseCount().pipe(take(1)),
      pending: this.caseService.getPendingCaseCount().pipe(take(1)),
      onHold: this.caseService.getOnHoldCaseCount().pipe(take(1)),
      rejected: this.caseService.getRejectedCaseCount().pipe(take(1)),
      active: this.caseService.getActiveCaseCount().pipe(take(1)),
      accepted: this.caseService.getacceptedCaseCount().pipe(take(1)),
      completed: this.caseService.getCompletedCaseCount().pipe(take(1)),
      cancelled: this.caseService.getCancelledCaseCount().pipe(take(1)),
    }).subscribe(({ draft, pending, onHold, rejected, active, accepted, completed, cancelled }) => {
      const allMetrics = [
        { title: 'Draft', count: draft, filterValue: 'draft', icon: iconMap['Draft'] },
        { title: 'Submitted', count: pending + onHold + rejected, filterValue: 'pending', icon: iconMap['Pending'] },
        { title: 'Active', count: active + accepted, filterValue: 'active', icon: iconMap['Active'] },
        { title: 'Completed', count: completed, filterValue: 'completed', icon: iconMap['Completed'] },
        { title: 'Cancelled', count: cancelled, filterValue: 'cancelled', icon: iconMap['Cancelled'] },
      ];
      this.metrics.set(allMetrics);
    });
  }

  onFilterClick(metric: Metric): void {
    console.log('SidenavComponent: Filter clicked:', metric.filterValue);
    console.log('SidenavComponent: Filter clicked:', metric.filterValue);
    this.caseService.setFilter(metric);
    this.router.navigate(['/dashboard']);
  }

  /**
   * Handle "All Cases" filter - resets to show all cases without any filtering.
   */
  onAllCasesClick(): void {
    console.log('SidenavComponent: All Cases clicked');
    // Create a default metric to reset the filter
    const defaultMetric: Metric = { title: 'All Cases', count: 0, filterValue: '', icon: 'dashboard' };
    this.caseService.setFilter(defaultMetric);
    this.router.navigate(['/dashboard']);
  }
}
